<app-feature-list-container>
  <div class="grid-container">
    <!-- 1 -->
    <!-- Value: Status heat exchanger frost damage prevention possible values to show [ON/OFF] -->
    <!-- ventilation.heatExchanger.frostprotection -->
    <div class="grid-container-column">
      <app-feature-list-item
        *ngIf="heatExchangerfrostProtection$ | async | ready as feature"
        data-at-diagnostic-info="heat-exchanger-frost-protection"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_HEAT_EXCHANGER_FROST_DAMAGE_PREVENTION_STATUS'
            | translate
        }}:"
        [value]="feature.properties?.status?.value | translateState | uppercase"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- Filter status [OK / NOT OK] -->
      <app-feature-list-item
        *ngIf="filterRuntime$ | async | ready as feature"
        data-at-diagnostic-info="data-at-filter-status"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_STATUS' | translate
        }}:"
        value="{{
          feature.properties?.overdueHours?.value > 0
            ? ('GENERAL.NOT_OK' | translate)
            : ('GENERAL.OK' | translate)
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- Value: Operating hours ventilation engines -->
      <!-- ventilation.preHeater.statistics -->
      <app-feature-list-item
        *ngIf="preHeaterStatistics$ | async | ready as feature"
        data-at-diagnostic-info="engines-operating-hours"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_ENGINES_OPERATING_HOURS'
            | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.hours }} {{
          feature | unit: featurePropertyKey.hours
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- Filter lifetime -->
      <ng-container *ngIf="filterRuntime$ | async | ready as feature">
        <!-- Filter operating hours -->
        <app-feature-list-item
          data-at-diagnostic-info="filter-operating-hours"
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_OPERATING_HOURS'
              | translate
          }}"
          value="{{
            VentilationDiagnosticsHelpers.convertFilterRuntimeHours(
              feature.properties?.operatingHours?.value,
              false
            )
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
        <!-- Filter remaining runtime hours -->
        <app-feature-list-item
          *ngIf="
            Number(feature.properties?.overdueHours?.value | toFixed: 0) > 0;
            else remainingHours
          "
          class="error"
          data-at-diagnostic-info="data-at-filter-overdue-hours"
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_REMAINING_LIFETIME'
              | translate
          }}:"
          value="{{
            VentilationDiagnosticsHelpers.convertFilterRuntimeHours(
              feature.properties?.overdueHours?.value,
              true
            )
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
        <ng-template #remainingHours>
          <app-feature-list-item
            data-at-diagnostic-info="filter-remaining-hours"
            label="{{
              '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_REMAINING_LIFETIME'
                | translate
            }}:"
            value="{{
              VentilationDiagnosticsHelpers.convertFilterRuntimeHours(
                feature.properties?.remainingHours?.value,
                false
              )
            }}"
            [attr.data-feature]="feature.feature"
            [error]="feature | error"
          >
          </app-feature-list-item>
        </ng-template>
      </ng-container>
    </div>

    <div class="grid-container-column">
      <!-- Date last filter change -->
      <!-- ventilation.filter.runtime -->
      <app-feature-list-item
        *ngIf="lastFilterChange$ | async as date"
        data-at-diagnostic-info="last-filter-change"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_LAST_FILTER_CHANGE'
            | translate
        }}:"
        value="{{ date | date: 'shortDate' }}"
        [attr.data-feature]="'lastFilterChange'"
      >
      </app-feature-list-item>

      <!-- Date next filter change -->
      <!-- ventilation.filter.runtime -->
      <app-feature-list-item
        *ngIf="nextFilterChange$ | async as date"
        data-at-diagnostic-info="next-filter-change"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_NEXT_FILTER_CHANGE'
            | translate
        }}:"
        value="{{ date | date: 'shortDate' }}"
        [attr.data-feature]="'nextFilterChange'"
      >
      </app-feature-list-item>

      <!-- Date last service-->
      <!-- heating.service.timeBased -->
      <ng-container *ngIf="heatingServiceTimeBased$ | async | ready as feature">
        <app-feature-list-item
          *ngIf="feature.properties.lastService"
          data-at-diagnostic-info="last-service-date"
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_LAST_SERVICE_DATE'
              | translate
          }}:"
          value="{{ feature.properties?.lastService?.value | date: 'shortDate' | dash }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- Date next service -->
      <!-- heating.service.timeBased -->
      <ng-container *ngIf="heatingServiceTimeBased$ | async | ready as feature">
        <app-feature-list-item
          *ngIf="feature.properties.nextService"
          data-at-diagnostic-info="next-service-date"
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_NEXT_SERVICE_DATE'
              | translate
          }}:"
          value="{{ feature.properties?.nextService?.value | date: 'shortDate' | dash }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
      </ng-container>
    </div>

    <div class="grid-container-column">
      <!-- Level 1 -->
      <app-feature-list-item
        *ngIf="ventilationLevelOne$ | async | ready as feature"
        data-at-diagnostic-info="ventilation-level-one"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.LEVEL_ONE' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.volumeFlow }} {{
          feature | unit: featurePropertyKey.volumeFlow
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
      <!-- Level 2 -->
      <app-feature-list-item
        *ngIf="ventilationLevelTwo$ | async | ready as feature"
        data-at-diagnostic-info="ventilation-level-two"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.LEVEL_TWO' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.volumeFlow }} {{
          feature | unit: featurePropertyKey.volumeFlow
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
      <!-- Level 3 -->
      <app-feature-list-item
        *ngIf="ventilationLevelThree$ | async | ready as feature"
        data-at-diagnostic-info="ventilation-level-three"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.LEVEL_THREE' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.volumeFlow }} {{
          feature | unit: featurePropertyKey.volumeFlow
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
      <!-- Level 4 -->
      <app-feature-list-item
        *ngIf="ventilationLevelFour$ | async | ready as feature"
        data-at-diagnostic-info="ventilation-level-four"
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.LEVEL_FOUR' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.volumeFlow }} {{
          feature | unit: featurePropertyKey.volumeFlow
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </div>
  </div>
</app-feature-list-container>
